import React from 'react';
import Checkbox from "react-custom-checkbox";

class CustomCheckbox extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isChecked: false
    }
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { checked } = this.props;
    if (checked === true) {
      this.setState({ isChecked: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { checked } = nextProps;
    if (checked === true) {
      this.setState({ isChecked: true });
    }
  }

  handleOnChange() {
    this.setState({ isChecked: !this.state.isChecked });
    return !this.state.isChecked;
  }

  render() {
    const { name, value, onChange, className, label, containerClassName } = this.props;
    const { isChecked } = this.state;


    return (
      <Checkbox
        className={className}
        icon={<span className='checkBoxChecked' />}
        increaseArea="20%"
        checked={isChecked}
        name={name}
        value={value}
        label={label}
        labelStyle={{ margin: 0 }}
        containerClassName={containerClassName}
        onChange={() => onChange(this.handleOnChange())}
      />
    )
  }
}

export default CustomCheckbox;